import React from "react";
import { Link } from "react-router-dom";
import { QuillLogo } from "./QuillLogo";

export const Footer = () => {
  const [isAdmin, setIsAdmin] = React.useState(false);
  React.useEffect(() => {
    setIsAdmin(!!localStorage.getItem("rq_admin_token"));
  }, []);
  return (
    <footer className="w-full pt-16 pb-20" data-testid="site-footer">
      <div className="mx-auto max-w-[740px] px-6 md:px-8">
        <div className="flex justify-center mb-10">
          <QuillLogo height={88} />
        </div>
        <hr className="border-0 mx-auto" style={{ width: "72px", height: "0.75px", backgroundColor: "#7A2E2E" }} />
        <div className="mt-12 text-center">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#7A2E2E]">
            The Raven&rsquo;s Quill
          </p>
          <p className="mt-5 text-[15px] text-[#1C1A17]">
            Bespoke Legacy Preservation · Anthropological Biography
          </p>
          <p className="mt-2 text-[15px] text-[#6E6A5E]">Pretoria, South Africa</p>

          <div className="mt-10">
            <Link
              to="/commission"
              data-testid="footer-cta"
              className="inline-block text-[11px] uppercase tracking-[0.28em] text-[#7A2E2E] border-b border-[#7A2E2E] pb-1 transition-colors hover:text-[#1C1A17] hover:border-[#1C1A17]"
            >
              Request a Private Consultation
            </Link>
          </div>

          <p className="mt-8 text-[15px] text-[#1C1A17]">
            Life Study commissions, by enquiry:{" "}
            <a
              href="mailto:info@theravensquill.co.za"
              className="text-[#1C1A17] underline-offset-4 hover:text-[#7A2E2E] transition-colors"
              data-testid="footer-email"
            >
              info@theravensquill.co.za
            </a>
          </p>

          <p className="mt-4 text-[15px] text-[#1C1A17]">
            The Final Tribute, by telephone or WhatsApp:{" "}
            <a
              href="https://wa.me/27792818435"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#1C1A17] underline-offset-4 hover:text-[#7A2E2E] transition-colors"
              data-testid="footer-phone"
            >
              +27 79 281 8435
            </a>
          </p>

          <p className="mt-8 text-[13px] italic text-[#6E6A5E]">
            Only a few Life Studies are undertaken at a time.
          </p>

          <div className="mt-10">
            <Link
              to="/faq"
              data-testid="footer-faq-link"
              className="inline-block text-[11px] uppercase tracking-[0.28em] text-[#6E6A5E] transition-colors hover:text-[#7A2E2E]"
            >
              Frequently Asked Questions
            </Link>
          </div>

          <div className="mt-5">
            <Link
              to="/from-the-page"
              data-testid="footer-from-the-page-link"
              className="inline-block text-[11px] uppercase tracking-[0.28em] text-[#6E6A5E] transition-colors hover:text-[#7A2E2E]"
            >
              From the Page
            </Link>
          </div>

          <div className="mt-5">
            <Link
              to="/from-the-booklet"
              data-testid="footer-from-the-booklet-link"
              className="inline-block text-[11px] uppercase tracking-[0.28em] text-[#6E6A5E] transition-colors hover:text-[#7A2E2E]"
            >
              From the Booklet
            </Link>
          </div>

          <div className="mt-5">
            <Link
              to="/no-one-is-coming"
              data-testid="footer-book-link"
              className="inline-block text-[11px] uppercase tracking-[0.28em] text-[#6E6A5E] transition-colors hover:text-[#7A2E2E]"
            >
              The Book
            </Link>
          </div>

          <div className="mt-12">
            <Link
              to={isAdmin ? "/admin/enquiries" : "/admin"}
              data-testid="footer-admin-link"
              className="inline-block text-[10px] uppercase tracking-[0.3em] text-[#7A2E2E] transition-colors hover:text-[#1C1A17]"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
